import styled from "@emotion/styled";
import { Heading } from "../Heading";
import { Typography } from "../Typography";

export const CARD_WIDTH = 315;

export const Body = styled.div`
  flex-grow: 1;
  padding: 24px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.snowdrop};
  border-radius: 0 0 15px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
`;

export const Description = styled(Typography)`
  margin-top: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 17px;
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 10px;
  height: 30px;
  margin-bottom: 12px;
`;

export const ImageContainer = styled.article`
  position: relative;
  height: 300px;
  border-radius: 15px 15px 0 0;
  overflow: hidden;
`;

export const CentredBadge = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
`;

export const Title = styled(Heading)`
  margin-bottom: 16px !important;
`;

export const Subtitle = styled(Typography)`
  font-size: 16px;
`;

export const Cost = styled(Typography)`
  font-size: 14px !important;
`;

export const Wrapper = styled.button`
  all: unset;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border: none;
  background-color: transparent;
  min-width: ${CARD_WIDTH}px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.forest}`};
  }
  &:hover:enabled {
    opacity: 80%;
  }
`;
